/* eslint-disable no-unused-vars */
const { feWp } = window;
const { addAction } = feWp.hooks;

// Function to stop autoplay on the slider object
const stopAutoPlay = ( sliderObj ) => {
  sliderObj.autoplay.stop();
};

addAction(
  'b3rg_slider_init',
  'b3rg/slider',
  ( settings, el, swiper ) => {
    if ( swiper.el.closest( '.e-stn--testimonial-slider .swiper' ) ||
      swiper.el.closest( '.e-stn--testimonial-slider-bg .swiper' ) ) {
      const arrows = swiper.el.querySelectorAll( '.e-sld__btn' );
      arrows.forEach( arrow => {
        arrow.addEventListener( 'click', () => {
          stopAutoPlay( swiper );
        } );
      } );
      swiper.on( 'click', function () {
        el.classList.add( 'autoplay-stop' );
        stopAutoPlay( swiper );
      } );
      swiper.on( 'touchStart', function () {
        el.classList.add( 'autoplay-stop' );
        stopAutoPlay( swiper );
      } );
      swiper.on( 'slideChangeTransitionStart', function () {
        el.classList.add( 'slide-changing' );
      } );
      swiper.on( 'slideChangeTransitionEnd', function () {
        el.classList.remove( 'slide-changing' );
      } );
      if ( swiper.slides.length === swiper.params.slidesPerView ) {
        el.classList.add( 'all-slides-visible' );
      }
    }
  },
  10,
  1,
);